export default __webpack_public_path__ + "static/media/lifeleech.a314ff9a.png";